import _sfc_main from "./VideoMediaControl.vue2.mjs";
/* empty css                        */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", [_c("div", { directives: [{ name: "click-outside", rawName: "v-click-outside", value: _setup.handleHideVideoSettingTab, expression: "handleHideVideoSettingTab" }], staticClass: "video-control-container" }, [_c(_setup.IconButton, { attrs: { "title": _setup.t("Camera"), "has-more": _vm.hasMore, "disabled": _vm.isDisabled, "is-not-support": !_setup.isSupportVideoMedia }, on: { "click-icon": _setup.handleClickIcon, "click-more": _setup.handleMore } }, [_c(_setup.SvgIcon, { attrs: { "icon": _setup.icon } })], 1), _c(_setup.VideoSettingTab, { directives: [{ name: "show", rawName: "v-show", value: _setup.showVideoSettingTab, expression: "showVideoSettingTab" }], staticClass: "video-tab", attrs: { "with-mirror": true, "theme": "white" } })], 1)]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "64a65f13"
);
const VideoMediaControl = __component__.exports;
export {
  VideoMediaControl as default
};
